export const messages = {
  en: {
    accountBank: {
      title: 'Account Bank Management',
      queryCondition: 'Query Condition',
      bankInfo: 'Bank Information',
      bankId: 'Bank ID',
      bankCode: 'Bank Account',
      personName: 'Card Holder',
      personTel: 'Phone Number',
      bankName: 'Bank Name',
      operation: 'Operation',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel',
      save: 'Save',
      back: 'Back',
      addTitle: 'Add Bank Account',
      editTitle: 'Edit Bank Account',
      deleteTitle: 'Confirm Operation',
      deleteContent: 'Are you sure to delete this bank account?',
      required: 'This field is required',
      maxLength: 'Exceeds maximum length',
      phoneFormat: 'Invalid phone format',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    accountBank: {
      title: '开户行管理',
      queryCondition: '查询条件',
      bankInfo: '开户行信息',
      bankId: '银行编号',
      bankCode: '银行账号',
      personName: '持卡人',
      personTel: '手机号',
      bankName: '开户行',
      operation: '操作',
      add: '添加',
      edit: '修改',
      delete: '删除',
      confirmDelete: '确认删除',
      cancel: '取消',
      save: '保存',
      back: '返回',
      addTitle: '添加开户行',
      editTitle: '修改开户行',
      deleteTitle: '请确认您的操作',
      deleteContent: '确定删除开户行',
      required: '该字段不能为空',
      maxLength: '超过最大长度限制',
      phoneFormat: '手机号格式不正确',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功'
    }
  }
}